// طباعة إيصال الكاشير عبر إطار (iframe) معزول.
//
// لماذا iframe؟ نضع المحتوى في مستند مستقل بأنماط مدمجة inline لضمان طباعة
// ثابتة بعرض 80مم (طابعة الكاشير الحرارية) بصرف النظر عن حالة Tailwind أو
// Vite dev/build، ولتجنّب طباعة الصفحة الكاملة خلف المودال.
//
// الطباعة الصامتة (Silent print):
// 1. اجعل طابعتك الحرارية هي الطابعة الافتراضية في ويندوز.
// 2. شغّل التطبيق عبر `node start.js --open` — يفتح Chrome مع
//    `--kiosk-printing` تلقائيّاً، فتُنفَّذ window.print() مباشرة دون حوار.
// 3. أو شغّل Chrome يدويّاً: chrome --kiosk-printing --app=http://localhost:6707
//
// المشكلة السابقة: استخدام document.write() + iframe بأبعاد 0×0 + الاعتماد
// على نسخ خارجي للأنماط (link/style من الـ window الأصلي) كان يؤدي إلى صفحة
// طباعة فارغة 100% من المرات في Chrome، خاصة في وضع التطوير.
//
// الحل الحالي: srcdoc + أنماط مدمجة كاملة + iframe بأبعاد ملموسة خارج الشاشة
// + انتظار جاهزية الخطوط والصور + تنظيف عبر afterprint.

// CSS الطباعة المدمج. يحاكي الـ Tailwind classes المستخدمة فعلياً في الإيصالات
// (flex/justify-between/border-dashed/text-*/font-*/my-1...) حتى لا نعتمد على
// تحميل Tailwind داخل الـ iframe.
const PRINT_CSS = `
/* ورق 80mm فعلي. الطابعات الحرارية تترك ~2-4mm حاشية غير قابلة للطباعة
   على كل جانب، لذا نُبقي المحتوى داخل 76mm ونركّزه ليكون آمناً. */
@page { size: 80mm auto; margin: 0; }
html, body {
  margin: 0;
  padding: 0;
  background: #fff;
  color: #000;
}
body {
  width: 80mm;
  font-family: 'Tajawal', 'Cairo', sans-serif;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.receipt-print-area {
  width: 76mm;
  box-sizing: border-box;
  margin: 0 auto;
  /* حاشية يسرى موسّعة (6mm) لتعويض المنطقة غير القابلة للطباعة في طابعات 80mm
     الحرارية وتفادي قص الحافة اليسرى. اليمين/الأعلى/الأسفل بدون تغيير. */
  padding: 2mm 3mm 2mm 6mm;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.45;
  color: #000;
  background: #fff;
  box-shadow: none !important;
  border-radius: 0 !important;
}
.receipt-print-area * {
  font-weight: 700 !important;
  color: #000 !important;
  box-sizing: border-box;
}
.receipt-print-area img {
  filter: none !important;
  max-width: 100%;
  display: block;
}
/* شعار المركز أعلى الإيصال ووسطه. الأبعاد بالمليمتر لتكون مستقلة عن دقة
   الشاشة، و auto للعرض/الارتفاع يحفظ نسبة أبعاد الصورة بلا تمديد. */
.receipt-print-area .receipt-logo {
  max-width: 50mm !important;
  max-height: 22mm !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain;
  margin: 0 auto 1mm;
}
/* Tailwind layout utilities used in the receipts (مدمجة inline لضمان عملها بدون Tailwind) */
.receipt-print-area .flex { display: flex; }
.receipt-print-area .flex-col { flex-direction: column; }
.receipt-print-area .items-center { align-items: center; }
.receipt-print-area .justify-between { justify-content: space-between; }
.receipt-print-area .text-center { text-align: center; }
.receipt-print-area .truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.receipt-print-area .mx-auto { margin-left: auto; margin-right: auto; }
.receipt-print-area .mb-1 { margin-bottom: 4px; }
.receipt-print-area .my-1 { margin-top: 4px; margin-bottom: 4px; }
.receipt-print-area .mt-1\\.5 { margin-top: 6px; }
.receipt-print-area .mt-2 { margin-top: 8px; }
.receipt-print-area .p-4 { padding: 16px; }
/* النص: حجم الخط في الإيصال صغير لكن بولد (الإيصال نفسه يستخدم أحجام صغيرة) */
.receipt-print-area .text-\\[10px\\] { font-size: 12px; }
.receipt-print-area .text-\\[11px\\] { font-size: 12px; }
.receipt-print-area .text-\\[12px\\] { font-size: 14px; }
.receipt-print-area .text-\\[13px\\] { font-size: 14px; }
.receipt-print-area .text-\\[14px\\] { font-size: 16px; }
.receipt-print-area .text-\\[15px\\] { font-size: 17px; }
.receipt-print-area .text-\\[16px\\] { font-size: 18px; }
.receipt-print-area .text-\\[18px\\] { font-size: 20px; }
.receipt-print-area .font-semibold { font-weight: 700 !important; }
.receipt-print-area .font-bold { font-weight: 800 !important; }
.receipt-print-area .font-extrabold { font-weight: 900 !important; font-size: 20px; }
/* الفاصل المنقّط */
.receipt-print-area hr {
  border: none;
  border-top: 1px dashed #000;
  margin: 6px 0;
}
.receipt-print-area .border-dashed {
  border-style: dashed !important;
  border-color: #000;
}
`;

function buildHtml(innerHTML) {
  return (
    `<!DOCTYPE html><html dir="rtl" lang="ar"><head><meta charset="utf-8">` +
    `<style>${PRINT_CSS}</style>` +
    `</head><body><div class="receipt-print-area">${innerHTML}</div></body></html>`
  );
}

function waitForImages(doc) {
  const imgs = Array.from(doc.querySelectorAll('img'));
  if (imgs.length === 0) return Promise.resolve();
  return Promise.all(
    imgs.map((img) => {
      if (img.complete && img.naturalWidth !== 0) return Promise.resolve();
      return new Promise((resolve) => {
        const done = () => resolve();
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
    })
  );
}

async function printIframe(html) {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  // أبعاد ملموسة خارج الشاشة — Chrome يرفض طباعة iframe بحجم 0×0 صامتاً.
  iframe.style.position = 'fixed';
  iframe.style.left = '-10000px';
  iframe.style.top = '0';
  iframe.style.width = '80mm';
  iframe.style.height = '297mm';
  iframe.style.border = '0';
  iframe.style.opacity = '0';
  iframe.style.pointerEvents = 'none';
  iframe.srcdoc = html;
  document.body.appendChild(iframe);

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    try {
      iframe.remove();
    } catch (_) {
      /* ignore */
    }
  };

  // ضمان نهائي للتنظيف حتى لو فشل كل شيء
  const safetyCleanup = setTimeout(cleanup, 60000);

  await new Promise((resolve) => {
    if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
      resolve();
    } else {
      iframe.addEventListener('load', () => resolve(), { once: true });
    }
  });

  const win = iframe.contentWindow;
  const doc = iframe.contentDocument;
  if (!win || !doc) {
    clearTimeout(safetyCleanup);
    cleanup();
    return;
  }

  // ننتظر جاهزية الخطوط (Tajawal/Cairo) لتفادي تخطيط متعرّج لحظة الطباعة
  try {
    if (doc.fonts && typeof doc.fonts.ready?.then === 'function') {
      await doc.fonts.ready;
    }
  } catch (_) {
    /* ignore */
  }

  // ننتظر تحميل الصور (شعار العلامة)
  try {
    await waitForImages(doc);
  } catch (_) {
    /* ignore */
  }

  // تنظيف عبر afterprint عند إغلاق المستخدم لحوار الطباعة
  win.addEventListener('afterprint', () => {
    clearTimeout(safetyCleanup);
    cleanup();
  });
  // Safari/iOS: قد لا يطلق afterprint، نحتفظ بـ safety cleanup فوق.

  try {
    win.focus();
    win.print();
  } catch (_) {
    clearTimeout(safetyCleanup);
    cleanup();
  }
}

export function printReceipt() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const area = document.querySelector('.receipt-print-area');
  if (!area) {
    // لا يوجد إيصال معروض — اطبع الصفحة كما هي (آخر منفذ)
    window.print();
    return;
  }

  const html = buildHtml(area.innerHTML);
  // لا نريد await هنا (الواجهة لا تنتظر)؛ نسمح للوعد بالعمل في الخلفية.
  void printIframe(html);
}
